import { Organization } from "../organization";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { CallCenterAlert } from "../call-center-alert";
import { CallCenterChatMessage } from "../call-center-chat-message";
import { CallCenterShift } from "../call-center-shift";
import { CallCenterVolunteerGroup } from "../call-center-volunteer-group";
import { CallCenterVolunteerEntityConfig } from "./config";
import { CallCenterVolunteerFilters } from "./filters";
import { CallCenterVolunteerMethods } from "./methods";

@HyperEntity<CallCenterVolunteer>(
  "call-center-volunteer",
  CallCenterVolunteerEntityConfig,
)
export class CallCenterVolunteer extends extender(
  CallCenterVolunteerFilters,
  CallCenterVolunteerMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "organization_id", caption: "ארגון" })
  organizationId = "";

  @Relations.toOne(() => Organization, "organizationId")
  organization?: Organization;

  @Fields.string({ dbName: "group_id", allowNull: true, caption: "קבוצת מוקד" })
  groupId?: string;

  @Relations.toOne(() => CallCenterVolunteerGroup, {
    caption: "קבוצת מוקד",
    field: "groupId",
  })
  group?: CallCenterVolunteerGroup;

  @Relations.toMany(() => CallCenterShift, "volunteerId")
  shifts?: CallCenterShift[];

  @Relations.toMany(() => CallCenterChatMessage, "volunteerId")
  chatMessages?: CallCenterChatMessage[];

  @Relations.toMany(() => CallCenterAlert, "volunteerId")
  alerts?: CallCenterAlert[];

  @Fields.string({ caption: "שם" })
  name = "";

  @Fields.string({ dbName: "phone_number", caption: "טלפון" })
  phoneNumber = "";

  @Fields.integer({ dbName: "ability_level", caption: "רמת יכולת" })
  abilityLevel = 3;

  @Fields.integer({ dbName: "daily_goal", caption: "יעד יומי" })
  dailyGoal = 8;

  @Fields.integer({ dbName: "daily_goal_cap", caption: "תקרת יעד" })
  dailyGoalCap = 40;

  @Fields.string({ dbName: "manager_notes", caption: "הערות רכז" })
  managerNotes = "";

  @Fields.string({
    dbName: "next_shift_reminders",
    caption: "תזכורות למשמרת הבאה",
  })
  nextShiftReminders = "";

  @Fields.boolean({ dbName: "is_active", caption: "פעיל" })
  isActive = true;

  @Fields.date({ dbName: "first_shift_at", allowNull: true, caption: "משמרת ראשונה" })
  firstShiftAt?: Date;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
